module.exports = __webpack_public_path__ + "static/media/task.dc82c937.svg";